export default __webpack_public_path__ + "static/media/marketLogo.bef48886.jpg";